import { useState } from "react";


export const useDeleteCrecaAccountStates = () => {
  const [crecaAccountId, setCrecaAccountId] = useState("");
  const [institutionType, setInstitutionType] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    crecaAccountId,
    institutionType,
    setCrecaAccountId,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
